import {
  getCheckDomain,
  getCheckEmail,
  getCheckEname,
  getCheckPhone,
  getIsVerification,
  getVerification,
  login,
  logout,
  modifyPassword,
  postCheckMaktet,
  postRegist,
  postSendsms,
  rainbondLogin,
  retrievePassword
} from '@/api/login';
import {
  fetchPlatformInfo,
  fetchUserAuthList,
  fetchUserInfo,
  fetchUserOrgList
} from '@/api/user';
import { getToken, removeToken, setToken } from '@/utils/auth';

const user = {
  state: {
    token: getToken(),
    userInfo: {},
    userAuths: null,
    userOrgs: [],
    platformInfo: {}
  },

  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_USER_AUTH: (state, auths) => {
      state.userAuths = auths;
    },
    SET_USER_ORG: (state, orgs) => {
      state.userOrgs = orgs;
    },
    SET_PLATFORM_INFO: (state, info) => {
      state.platformInfo = info;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_RESET: (state) => {
      removeToken();
      state.token = '';
      state.name = '';
      state.avatar = '';
      state.userInfo = {};
    }
  },

  actions: {
    // 登录
    Login({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        login(resdata)
          .then((response) => {
            const tokenStr = response.token;
            setToken(tokenStr);
            commit('SET_TOKEN', tokenStr);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // rainbond登录
    rainbondLogin({ commit }, { payload }) {
      return new Promise((resolve, reject) => {
        rainbondLogin(payload)
          .then((res) => {
            const tokenKey = res.token;
            // 存放Cookie
            setToken(tokenKey);
            // 存放state
            commit('SET_TOKEN', tokenKey);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    SetToken({ commit }, resdata) {
      setToken(resdata);
      commit('SET_TOKEN', resdata);
    },
    // 验证码
    Verification() {
      return new Promise((resolve, reject) => {
        getVerification()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 显示验证码
    IsVerification() {
      return new Promise((resolve, reject) => {
        getIsVerification()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 注册
    Regist({ commit }, userdata) {
      return new Promise((resolve, reject) => {
        postRegist(userdata)
          .then((response) => {
            const tokenStr = response.token;
            if (tokenStr) {
              setToken(tokenStr);
              commit('SET_TOKEN', tokenStr);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 检测注册企业名称
    checkEname(_, data) {
      return new Promise((resolve, reject) => {
        getCheckEname(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 检测注册企业名称
    checkDomain(_, data) {
      return new Promise((resolve, reject) => {
        getCheckDomain(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 检测注册手机号
    checkPhone(_, data) {
      return new Promise((resolve, reject) => {
        getCheckPhone(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 检测注册邮箱
    checkEmail(_, data) {
      return new Promise((resolve, reject) => {
        getCheckEmail(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 检测注册商店
    checkMaktet(_, data) {
      return new Promise((resolve, reject) => {
        postCheckMaktet(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 发送短信验证码
    Sendsms({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        postSendsms(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 找回密码
    RetrievePassword({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        retrievePassword(resdata)
          .then((response) => {
            const tokenStr = response.data;
            commit('SET_TOKEN', tokenStr);
            setToken(tokenStr);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 修改密码
    ModifyPassword({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        modifyPassword(resdata)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchUserInfo()
          .then((response) => {
            commit('SET_USER_INFO', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户权限信息
    GetUserAuthList({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchUserAuthList()
          .then((response) => {
            commit('SET_USER_AUTH', response.permissions);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetUserOrgList({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchUserOrgList()
          .then((response) => {
            commit('SET_USER_ORG', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取平台基础信息
    GetPlatformInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchPlatformInfo()
          .then((response) => {
            commit('SET_PLATFORM_INFO', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then((response) => {
            localStorage.clear();
            commit('SET_RESET');
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js